import Vue from 'vue';
const stopDrag = Vue.directive('stopDrag', {
    inserted: function (el,binding,vbode) {
        let element = el;
        element.onmousedown = function (e){
            e.stopPropagation()
        }
    },
})
export default stopDrag;